import { NgModule, CUSTOM_ELEMENTS_SCHEMA, importProvidersFrom, isDevMode, } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { loginRequest, msalConfig, protectedResources } from './b2c-config';
import { MsalBroadcastService, MsalGuard, MsalGuardConfiguration, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalRedirectComponent, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from "ngx-spinner";
import { CookieService } from 'ngx-cookie-service';
import { AuthGuard } from './utilities/auth/auth.guard';
import { AuthService } from './utilities/auth/auth.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalPopupComponent } from './layout/modal-popup/modal-popup.component';
import { LoggingService } from './utilities/logging/logging.service';
import { UnAuthorizedComponent } from './un-authorized/un-authorized.component';
import { ToastNotificationComponent } from './shared/toast-notification/toast-notification.component';
import { ToastNotificationService } from './shared/toast-notification/toast-notification.service';
import { TranslocoHttpLoader, TranslocoRootModule } from './utilities/transloco/transloco-root.module';
import { MaterialModule } from './user-management/material.module';
import { DataPersistenceGuard } from './utilities/data-persistence/data-persistence.guard';
import { SetServiceKeyComponent } from './layout/service-user-authentication/set-service-key/set-service-key.component';
import { ServiceKeyGenericDialogComponent } from './layout/service-user-authentication/service-key-generic-dialog/service-key-generic-dialog.component';
import { SharedModule } from './shared/shared.module';
import { provideTransloco } from '@ngneat/transloco';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>(); 
  protectedResourceMap.set(protectedResources.etlApi.endpoint, protectedResources.etlApi.scopes);
  protectedResourceMap.set(protectedResources.realizerApi.endpoint,protectedResources.realizerApi.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest,
    loginFailedRoute: ''
  };
}

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    ModalPopupComponent,
    UnAuthorizedComponent,
    ToastNotificationComponent,
    SetServiceKeyComponent,
    ServiceKeyGenericDialogComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    MsalModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TranslocoRootModule,
    MaterialModule,
    SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    CookieService,
    AuthGuard,
    AuthService, 
    LoggingService,
    ToastNotificationService,
    DataPersistenceGuard,
    provideTransloco({
      config: {
        availableLangs: ['en'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
